import styled from 'styled-components';

import { BRAND_ENERGY_GRADIENT } from 'utils/color/horizonTheme';

export const MaintenanceContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  justify-content: space-around;
  margin: 0;
  min-height: 100vh;
  padding: 0 2em;
  position: relative;
  text-align: center;

  /* Energy Gradient accent stripe (Sky Blue → Sprout Green → Gold). */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: ${BRAND_ENERGY_GRADIENT};
  }
`;

export const PrimaryLogo = styled.img`
  width: 75vw;

  @media screen and (min-width: 900px) {
    width: 60vw;
  }
`;

export const SkySpecsLogo = styled.img`
  width: 40vw;

  @media screen and (min-width: 900px) {
    width: 20vw;
  }
`;
